import { SaveOutlined, UndoOutlined } from '@ant-design/icons';
import { Button, Checkbox, Col, DatePicker, Form, Row, Table } from 'antd';
import { useForm } from 'antd/es/form/Form';
import TextArea from 'antd/es/input/TextArea';
import Column from 'antd/es/table/Column';
import { Space } from 'antd/lib';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import ModalTextForm from '../../components/modal/ModalTextForm';
import { idNhomKPI } from '../../constants';
import { ChiTietKPITrangChu } from '../../models/kpi/KPICaNhan';
import { luuGiaoViecKPI } from '../../services/kpi';
import { hideLoadingScreen, showLoadingScreen } from '../../store/reducers/loading';
import NhanVienPhongBanSelectBox from '../utils/NhanVienPhongBanSelectBox';

const GiaoViecKPI = () => {
    const dispatch = useDispatch();
    const [form] = useForm();
    const [confirmModal, setConfirmModal] = useState<any>({});
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState<Array<ChiTietKPITrangChu>>([]);
    const idNhanViens = Form.useWatch('idNhanViens', form);
    const tenCongViec = Form.useWatch('tenCongViec', form);
    const coNhanSuXuLy = Array.isArray(idNhanViens) ? idNhanViens.length > 0 : idNhanViens != null;
    const coTenCongViec = (tenCongViec || "").trim().length > 0;
    const hienNutLuu = coNhanSuXuLy && coTenCongViec;

    const defaultData: Array<ChiTietKPITrangChu> = [{
        key: 0,
        id: 0,
        idKPI: 0,
        idNhomKPI: idNhomKPI.chuyenMon,
        tenCongViec: "",
        thoiGianGiao: dayjs().startOf('month').toDate(),
        thoiGianYeuCauHoanThanh: dayjs().endOf('month').toDate(),
        ghiChu: "",
        choSuaThoiGianHT: true,
        baoCaoCapTren: true
    }];

    type FieldChiTietKPI = {
        "tenCongViec": string;
        "thoiGianGiao": Date;
        "thoiGianYeuCauHoanThanh": Date;
        "ghiChu": string;
        "idNhanViens": number[];
        "choSuaThoiGianHT": boolean;
        "baoCaoCapTren": boolean;
    };

    const onFinish = (values: any) => {

        const thang = values.thoiGianGiao.month() + 1;
        const nam = values.thoiGianGiao.year();
        setConfirmModal({
            isShowModal: true,
            title: "Tạo công việc yêu cầu báo cáo",
            content:
                <>Bạn có muốn lưu <label>Công việc</label> này vào KPI tháng {thang}/{nam} cho nhân viên đã chọn không?</>,
            onSubmit: eventSaveChiTietKPI
        });
    };

    const eventSaveChiTietKPI = async () => {
        if (isLoading) return;
        form.validateFields().then(async (values: {
            tenCongViec: string;
            thoiGianGiao: { $d: any; };
            thoiGianYeuCauHoanThanh: { $d: any; };
            ghiChu: string;
            idNhanViens: Array<number>;
            choSuaThoiGianHT: boolean;
            baoCaoCapTren: boolean;
        }) => {
            dispatch(showLoadingScreen())
            setIsLoading(true);
            try {
                var request = {
                    tenCongViec: values.tenCongViec,
                    thoiGianGiao: values.thoiGianGiao.$d,
                    thoiGianYeuCauHoanThanh: values.thoiGianYeuCauHoanThanh.$d,
                    ghiChu: values.ghiChu,
                    choSuaThoiGianHT: values.choSuaThoiGianHT,
                    baoCaoCapTren: values.baoCaoCapTren,
                    idNhanViens
                };
                await luuGiaoViecKPI(request);
                eventResetKPI();
                toast.success("Tạo công việc yêu cầu báo cáo thành công");
            } catch (error: any) {
                toast.error(error);
            }
            setIsLoading(false);
            dispatch(hideLoadingScreen());
        }).catch((e: any) => {
            toast.error(e);
            dispatch(hideLoadingScreen());
        });
    }

    const eventResetKPI = () => {
        form.setFieldsValue({
            tenCongViec: "",
            thoiGianGiao: dayjs().startOf('month'),
            thoiGianYeuCauHoanThanh: dayjs().endOf('month'),
            ghiChu: "",
            idNhanViens: [],
            choSuaThoiGianHT: true,
            baoCaoCapTren: true
        });
    }

    useEffect(() => {
        form.setFieldsValue({
            tenCongViec: "",
            thoiGianGiao: dayjs().startOf('month'),
            thoiGianYeuCauHoanThanh: dayjs().endOf('month'),
            ghiChu: "",
            idNhanViens: [],
            choSuaThoiGianHT: true,
            baoCaoCapTren: true
        });
        setData(defaultData);
    }, []);

    return (
        <>
            <Col xs={24} xl={24}>
                <Row style={{ marginBottom: "10px" }}>
                    <Col span="12">
                        <Row><b style={{ fontSize: "20px", color: "#071C50" }}>Công việc yêu cầu báo cáo</b></Row>
                    </Col>
                </Row>
                <Row>
                    <div className="card" style={{ width: "100%" }}>
                        <Form
                            layout="vertical"
                            onFinish={onFinish}
                            onSubmitCapture={(e) => e.preventDefault()}
                            form={form}
                        >
                            <Table
                                scroll={{ x: "max-content" }}
                                pagination={false}
                                size="small"
                                dataSource={(data || []).map((x: ChiTietKPITrangChu, idx: number) => { x.key = idx; return x; })}
                            >
                                <Column
                                    title="Nội dung"
                                    key="tenCongViec"
                                    dataIndex="tenCongViec"
                                    render={(value, record, index) => {
                                        return (
                                            <Form.Item<FieldChiTietKPI>
                                                name="tenCongViec"
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: "Tên công việc bắt buộc nhập"
                                                    }
                                                ]}
                                            >
                                                <TextArea rows={2}
                                                    value={value}
                                                    placeholder="Nhập công việc"
                                                />
                                            </Form.Item>
                                        );
                                    }}
                                />
                                <Column
                                    align="center"
                                    title="Thời gian giao"
                                    key="thoiGianGiao"
                                    dataIndex="thoiGianGiao"
                                    width="150px"
                                    render={(value, record, index) => {
                                        return (
                                            <div style={{ textAlign: "left" }}>
                                                <Form.Item<FieldChiTietKPI>
                                                    name="thoiGianGiao"
                                                    style={{ marginBottom: 4 }}
                                                >
                                                    <DatePicker
                                                        changeOnBlur={true}
                                                        allowClear={false}
                                                        value={dayjs(value)}
                                                        picker="date"
                                                        format={["DD/MM/YYYY", "DDMMYYYY"]}
                                                        onChange={(e: any) => {
                                                            const updates: any = { thoiGianGiao: e };
                                                            const thoiGianYeuCauHoanThanh = form.getFieldValue("thoiGianYeuCauHoanThanh");
                                                            if (e && thoiGianYeuCauHoanThanh && e.isAfter(thoiGianYeuCauHoanThanh)) {
                                                                updates.thoiGianYeuCauHoanThanh = e;
                                                            }
                                                            form.setFieldsValue(updates);
                                                        }}
                                                    />
                                                </Form.Item>
                                                <Form.Item<FieldChiTietKPI>
                                                    name="baoCaoCapTren"
                                                    valuePropName="checked"
                                                    style={{ marginBottom: 0 }}
                                                >
                                                    <Checkbox title="Báo cáo cấp trên">Báo cáo</Checkbox>
                                                </Form.Item>
                                            </div>
                                        );
                                    }}
                                />
                                <Column
                                    align="center"
                                    title="Thời gian hoàn thành"
                                    key="thoiGianYeuCauHoanThanh"
                                    dataIndex="thoiGianYeuCauHoanThanh"
                                    width="170px"
                                    render={(value, record, index) => {
                                        return (
                                            <div style={{ textAlign: "left" }}>
                                                <Form.Item<FieldChiTietKPI>
                                                    name="thoiGianYeuCauHoanThanh"
                                                    style={{ marginBottom: 4 }}
                                                >
                                                    <DatePicker
                                                        style={{ width: "100%" }}
                                                        changeOnBlur={true}
                                                        allowClear={true}
                                                        placeholder="Chọn ngày"
                                                        value={dayjs(value)}
                                                        picker="date"
                                                        format={["DD/MM/YYYY", "DDMMYYYY"]}
                                                        onChange={(e: any) => {
                                                            form.setFieldsValue({
                                                                thoiGianYeuCauHoanThanh: e,
                                                            });
                                                        }}
                                                    />
                                                </Form.Item>
                                                <Form.Item<FieldChiTietKPI>
                                                    name="choSuaThoiGianHT"
                                                    valuePropName="checked"
                                                    style={{ marginBottom: 0 }}
                                                >
                                                    <Checkbox title="Cho sửa thời gian yêu cầu hoàn thành">Cho sửa</Checkbox>
                                                </Form.Item>
                                            </div>
                                        );
                                    }}
                                />
                                <Column
                                    title="Ghi chú"
                                    key="ghiChu"
                                    dataIndex="ghiChu"
                                    width="200px"
                                    render={(value, record, index) => {
                                        return (
                                            <Form.Item<FieldChiTietKPI>
                                                name="ghiChu"
                                            >
                                                <TextArea rows={2}
                                                    value={value}
                                                    placeholder="Nhập ghi chú"
                                                />
                                            </Form.Item>
                                        );
                                    }}
                                />
                                <Column
                                    title="Nhân sự xử lý"
                                    key="idNhanViens"
                                    dataIndex="idNhanViens"
                                    width="250px"
                                    render={(value, record, index) => {
                                        return (
                                            <Form.Item<FieldChiTietKPI>
                                                name="idNhanViens"
                                            >
                                                <NhanVienPhongBanSelectBox giaoViec allowClear onChange={(e: any) => {
                                                    form.setFieldValue('idNhanViens', e.target.value);
                                                }} />
                                            </Form.Item>
                                        );
                                    }}
                                />
                                <Column
                                    align="center"
                                    title=""
                                    width="100px"
                                    dataIndex=""
                                    key=""
                                    render={(value, record, index) => {
                                        return (
                                            <Form.Item>
                                                <Space direction="vertical" size={4}>
                                                    {hienNutLuu &&
                                                        <Button
                                                            loading={isLoading}
                                                            className="btn-primary"
                                                            type="primary"
                                                            icon={<SaveOutlined rev="" />}
                                                            htmlType="submit"
                                                            size={"small"}
                                                            block
                                                        > Lưu
                                                        </Button>}
                                                    <Button
                                                        loading={isLoading}
                                                        className="hrm-btn-warning"
                                                        icon={<UndoOutlined rev="" />}
                                                        onClick={eventResetKPI}
                                                        size={"small"}
                                                        block
                                                    > Reset
                                                    </Button>
                                                </Space>
                                            </Form.Item>
                                        )
                                    }}
                                />
                            </Table>
                        </Form>
                        <ModalTextForm
                            show={confirmModal.isShowModal}
                            title={confirmModal.title}
                            handleClose={() => setConfirmModal({ isShowModal: false })}
                            handleSave={() => {
                                confirmModal.onSubmit();
                                setConfirmModal({ isShowModal: false });
                            }}
                        >
                            {confirmModal.content}
                        </ModalTextForm>
                    </div>
                </Row>
            </Col>
        </>
    );
};

export default GiaoViecKPI;
